import { reactive, watch } from 'vue';
import router from '@/router';

// All easter-egg state in one place: a reactive store, one namespaced storage
// key, and a single keyup listener fed by a rolling buffer. Because the flags
// are reactive, toggling an egg updates the UI live instead of forcing a
// full-page reload — the one exception is `substitutions`, which must re-fetch
// its (separate, unreliable) data feed, so it still reloads.
//
// This replaces the accreted version: a 256-char keyup buffer in App.vue plus
// scattered localStorage keys (`substitutions`, `canvasUserLinkEnabled`,
// `ENABLE_TICKBOX`) and location.reload() hacks.
const STORAGE_KEY = 'speedy:eggs';

function loadInitial() {
    var stored;
    try { stored = JSON.parse(localStorage[STORAGE_KEY] || '{}'); } catch { stored = {}; }
    // Migrate the old scattered keys the first time we see them, so existing users
    // don't have to re-enable their eggs — then delete them. If we left them, a
    // lingering legacy key would re-force its egg on every load and could never be
    // turned off. persist() (below) moves the values into STORAGE_KEY immediately.
    if (localStorage['substitutions']) { stored.substitutions = true; delete localStorage['substitutions']; }
    if (localStorage.canvasUserLinkEnabled === 'true') { stored.canvasUserLinkEnabled = true; delete localStorage['canvasUserLinkEnabled']; }
    if (localStorage['ENABLE_TICKBOX']) { stored.enableTickbox = true; delete localStorage['ENABLE_TICKBOX']; }
    return stored;
}

var initial = loadInitial();

const eggs = reactive({
    substitutions: !!initial.substitutions,
    canvasUserLinkEnabled: !!initial.canvasUserLinkEnabled, // devtools-set, no phrase
    enableTickbox: !!initial.enableTickbox,                 // devtools-set, no phrase
    historicalTimetables: false,                            // session-only, never persisted
});

function persist() {
    localStorage[STORAGE_KEY] = JSON.stringify({
        substitutions: eggs.substitutions,
        canvasUserLinkEnabled: eggs.canvasUserLinkEnabled,
        enableTickbox: eggs.enableTickbox,
    });
}
persist();                          // make any migrated flags durable immediately
watch(eggs, persist, { deep: true });

// Trigger phrase -> effect. Same phrases as before.
var buffer = '';
const triggers = [
    // persist() synchronously before the reload — the reactive watcher flushes on
    // nextTick, which would race the reload and lose the flag.
    { phrase: 'substitutions', run() { eggs.substitutions = true; persist(); location.reload(); } },
    { phrase: 'historicaltimetables', run() { eggs.historicalTimetables = true; } },
    { phrase: 'mastertimetable', run() { router.push('/master-timetable'); } },
];

export function startEggListener() {
    document.addEventListener('keyup', function (event) {
        buffer = (buffer + (event.key || '')).slice(-256);
        for (var i = 0; i < triggers.length; i++) {
            if (buffer.indexOf(triggers[i].phrase) !== -1) {
                triggers[i].run();
                buffer = '';
            }
        }
    });
}

export default eggs;
